import {GridBreakPointKeys} from "app/Interface/Content/Grid/WidgetGrid"
import SystemLayoutUiService, {SubscribeSystemLayoutUiService} from "app/Service/System/Layout/SystemLayoutUiService"
import WindowWidthService from "app/Service/Util/windowWidthService"
import Logger from "logger/logger"
import React, {useEffect, useState} from "react"
import {Dropdown, DropdownButton} from "react-bootstrap"

function ForceGridBreakpointButton() {

  const {width} = WindowWidthService("ForceGridBreakpointButton")
  const {breakpoint, breakpoints, forceBreakpoint, setForceBreakpoint} = SystemLayoutUiService([
    SubscribeSystemLayoutUiService.breakpoint,
    SubscribeSystemLayoutUiService.breakpoints,
    SubscribeSystemLayoutUiService.forceBreakpoint,
  ], 'ForceGridBreakpointButton')

  const [smallerBreakpoints, setSmallerBreakpoints] = useState<string[]>()

  useEffect(() => {
    if (undefined === breakpoints) return

    const smaller: GridBreakPointKeys[] = []
    const keys = Object.keys(breakpoints) as GridBreakPointKeys[]
    keys.map(bpk => {
      if (breakpoints[bpk] < width)
        if (undefined === forceBreakpoint) {
          if (bpk !== breakpoint)
            smaller.push(bpk)
        } else {
          if (bpk !== forceBreakpoint)
            smaller.push(bpk)
        }
    })
    setSmallerBreakpoints(smaller)
  }, [breakpoints, forceBreakpoint, width, breakpoint])

  useEffect(() => {
    Logger('ForceGridBreakpointButton.smallerBreakpoints', smallerBreakpoints)
  }, [smallerBreakpoints])

  return undefined === breakpoint ? null : (
    <DropdownButton id={'force-grid-breakpoint'} title={forceBreakpoint ?? breakpoint}>
      {smallerBreakpoints?.map(sbp => {
        return <Dropdown.Item key={sbp}
                              onClick={() => setForceBreakpoint(sbp as GridBreakPointKeys)}>{sbp}</Dropdown.Item>
      })}
    </DropdownButton>
  )
}

export default ForceGridBreakpointButton
